import React, { useRef } from "react";
import Hero from "../../components/hero/Hero";
import SmarterTrading from "../../components/smarterTrading/SmarterTrading";
import TradeSmarter from "../../components/tradeSmarter/TradeSmarter";
import Excellent from "../../components/excellent/Excellent";
import Passive from "../../components/passive/Passive";
import Leadership from "../../components/leadership/Leadership";
import Experience from "../../components/experience/Experience";
import ContactTeam from "../../components/contactTeam/ContactTeam";
import "../../components/smarterTrading/smarterTrading.scss";
import { Link } from "react-router-dom";
import bg from "../../img/tbg.png";
import "../../components/excellent/excellent.scss";
import Update from "../../components/update/Update";
import "./home.scss";
import { TiChartBar } from "react-icons/ti";
import { ImPower } from "react-icons/im";
import { FaRegClock } from "react-icons/fa6";
import { FaUserShield } from "react-icons/fa";
import Mission from "../../components/mission/Mission";


const Home = () => {
  const excellentRef = useRef(null);

  const scrollToExcellent = () => {
    excellentRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const advantages = [
    {
      icon: <ImPower />,
      label: "Speed",
      desc: "AI processes information in milliseconds, capturing fleeting alpha.",
    },
    {
      icon: <TiChartBar />,
      label: "Consistency",
      desc: "Algorithmic discipline eliminates emotional human bias.",
    },
    {
      icon: <FaRegClock />,
      label: "24/7 Scanning",
      desc: "Constant surveillance across all global time zones.",
    },
    {
      icon: <FaUserShield />,
      label: "Risk Control",
      desc: "Hard-coded stop-losses and position limits protect capital.",
    },
  ];

  return (
    <div className="__fw">
      <Hero />
      <Update />

      <div className="__mw">
        <Mission />
      </div>

      <div className="__mw">
        <section className="hybrid">
          <div className="hybrid__container">
            <div className="hybrid__grid">
              {/* Left Content */}
              <div className="hybrid__left">
                <div className="hybrid__tag">Hybrid Execution</div>
                <h2 className="hybrid__title">
                  Elite Growth Through <span>Strategic Intelligence</span>
                </h2>
                <p className="hybrid__main-desc">
                  Elite Software Solutions utilize a sophisticated hybrid
                  approach, combining manual expertise with advanced AI trading
                  systems to optimize your portfolio performance.
                </p>

                <div className="advantage-grid">
                  {advantages.map((adv, index) => (
                    <div className="adv-card" key={index}>
                      <div className="adv-card__icon">{adv.icon}</div>
                      <div className="adv-card__text">
                        <h6>{adv.label}</h6>
                        <p>{adv.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="hybrid__actions">
                  <Link to="/contact" className="btn-primary">
                    Contact Team
                  </Link>
                  <button className="btn-outline" onClick={scrollToExcellent}>
                    Explore Strategy
                  </button>
                </div>
              </div>

              {/* Right Image with Glow Effect */}
              <div className="hybrid__right">
                <div className="image-stack">
                  <div className="image-stack__glow"></div>
                  <img
                    src={require("../../img/robot.jpg")}
                    alt="AI Trading Interface"
                  />
                  <div className="image-stack__card">
                    <span>AI Core V.4</span>
                    <p>Status: Active</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="__mw">
        <TradeSmarter />
      </div> */}
      <div className="__mw" ref={excellentRef}>
        <div
          className="excellent_wrp"
          style={{
            backgroundImage: `url(${bg})`, // use template literal for the image
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="ex_head">
            <h4>
              Advanced AI Solutions <em> for Smarter Investing</em>{" "}
            </h4>
          </div>
          <div className="ex_cont_wrp">
            <div className="ex_sec">
              <div className="ex_lft">
                <h1>01</h1>
              </div>
              <div className="ex_rit">
                <h5>Intelligent Trading Powered by AI</h5>
                <p>
                  Trade with confidence as our AI continuously scans markets,
                  delivering accurate, actionable signals that help you make
                  smarter, more profitable decisions.
                </p>
              </div>
            </div>
            <div className="ex_sec">
              <div className="ex_lft">
                <h1>02</h1>
              </div>
              <div className="ex_rit">
                <h5>AI Trading Powered by Data & Machine Learning</h5>
                <p>
                  By combining advanced analytics with machine learning, our AI
                  decodes market trends instantly. It evolves with every trade,
                  providing smarter, more profitable trading signals over time.
                </p>
              </div>
            </div>
            <div className="ex_sec">
              <div className="ex_lft">
                <h1>03</h1>
              </div>
              <div className="ex_rit">
                <h5>AI-Driven Algorithmic Trading</h5>
                <p>
                  Our tested algorithmic strategies combine data analytics and
                  automation to act on market trends instantly. They eliminate
                  human bias, maintain speed, and deliver reliable, repeatable
                  trading performance.
                </p>
              </div>
            </div>
            <div className="ex_sec">
              <div className="ex_lft">
                <h1>04</h1>
              </div>
              <div className="ex_rit">
                <h5>AI-Powered Performance & Risk Control</h5>
                <p>
                  Track your trading results in real time with detailed
                  analytics. Our AI monitors markets and manages risk, helping
                  protect your capital while maximizing opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="__mw">
        <Passive />
      </div> */}
      <div className="__mw">
        <Experience />
        <ContactTeam />
      </div>
    </div>
  );
};

export default Home;
